export function getHeaders() {
  return new Headers({
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.access_token}`
  });
}

export function handleResponse(response) {
  if (!response.ok) {
    throw response;
  }

  return response.json();
}

export function handleErrorMessages(error, setErrorMessages) {
  try {
    error.json().then(messages => {
      setErrorMessages(messages || ["There was an error."]);
    });
  } catch (e) {
    setErrorMessages(["There was an error."]);
  }
}

// --- Session diagnostics ----------------------------------------------------
// A small on-device log of session events, so a surprise logout ("dropped to the
// login page") can be diagnosed from a screenshot of the login screen — no
// developer console required. Keeps the last ~25 events in localStorage.
export function logSession(event, extra) {
  try {
    const entry = {
      t: new Date().toISOString(),
      event,
      extra: extra || null
    };
    let log = [];
    try {
      log = JSON.parse(localStorage.getItem("lanis_session_log") || "[]");
    } catch (e) {
      log = [];
    }
    log.push(entry);
    if (log.length > 25) log = log.slice(log.length - 25);
    localStorage.setItem("lanis_session_log", JSON.stringify(log));
  } catch (e) {
    /* storage unavailable — ignore */
  }
}

export function getSessionLog() {
  try {
    return JSON.parse(localStorage.getItem("lanis_session_log") || "[]");
  } catch (e) {
    return [];
  }
}

export function removeAccessToken() {
  if (localStorage.access_token) {
    // Record WHO cleared the session and when, to localStorage AND the console,
    // so a surprise logout can be traced to its exact trigger without needing the
    // dev console open at the moment it happens.
    const stack = (new Error().stack || "(no stack)")
      .split("\n")
      .slice(1, 5)
      .join(" | ");
    logSession("token-removed", stack);
    try {
      // eslint-disable-next-line no-console
      console.warn("[LANIS] access_token removed — session cleared. " + stack);
    } catch (e) {
      /* console unavailable — ignore */
    }
    localStorage.removeItem("access_token");
  }
}

export function setAccessToken(token) {
  if (token) {
    localStorage.setItem("access_token", token);
    logSession("token-set");
  }
}

export function getAccessToken() {
  return localStorage.access_token;
}
